var Colours;
(function (Colours) {
    Colours["darkBlue"] = "#263238";
    Colours["alabaster"] = "#F7F7F7";
    Colours["doveGrey"] = "#6E6E6E";
    // colours above are currrently used in the current globalNav but will be removed once it is restyled to match the signed off design - JV 04.11.2021
    Colours["black"] = "#000";
    Colours["white"] = "#fff";
    Colours["primary"] = "#222239";
    Colours["secondary"] = "#0F0F22";
    Colours["tertiary"] = "#9CA0C0";
    Colours["quarternary"] = "#EAEDF5";
    Colours["quinternary"] = "#C1C4D9";
    Colours["sexternary"] = "#4e4e61";
    Colours["septernary"] = "#F7F9FD";
    Colours["inputBackground"] = "#f7f9fd";
    // status colors
    Colours["danger"] = "#E0032A";
    Colours["dangerLight"] = "rgba(224, 3, 42, 0.051)";
    Colours["success"] = "#4F9053";
    Colours["successLight"] = "rgba(0,175,0,0.051)";
    Colours["warning"] = "#EC9D56";
    Colours["warningLight"] = "rgba(255,177,0,0.051)";
    Colours["pointBorder"] = "rgba(175,175, 175, .2)";
})(Colours || (Colours = {}));
export default Colours;
//# sourceMappingURL=colours.js.map